import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ChangeDetectorRef, Injectable } from '@angular/core';
import { BaseSiteService, OccEndpointsService } from '@spartacus/core';
import { BehaviorSubject, map, take } from 'rxjs';
import * as _ from 'lodash';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OtpModalComponent } from '../modules/otp-modal/otp-modal/otp-modal.component';

@Injectable({
  providedIn: 'root',
})
export class MultiFactorAuthService {
  baseSiteId: any;
  multiFactorAuthResult: BehaviorSubject<any>;
  constructor(
    private readonly http: HttpClient,
    private readonly modalService: NgbModal,
    private occEndPoint: OccEndpointsService,
    private baseSiteService: BaseSiteService,
  ) {
    this.baseSiteService.getActive().pipe(take(1)).subscribe(res => this.baseSiteId = res);
  }

  multiFactorAuth(triggerLocation, params?, process?) {
    this.multiFactorAuthResult = new BehaviorSubject<any>(null);
    const loc = { gaProcess: triggerLocation }
    this.getMethodsOTP(params).subscribe((res) => {
        if (res?.length) {
          const content = {
            process: process,
            processCount: res?.length,
            methods: res
          }
          !_.isEmpty(_.filter(res, { limited: false })) || (params == 'mobile' && res[0]?.name == params)
          ? this.modalTrigger(loc, content)
          : this.modalTrigger(loc, null, true);
        } else {
          this.multiFactorAuthResult.next({ process: process, status: true });
        }
      }, (error) => {
        this.modalTrigger(loc, null, true);
        this.multiFactorAuthResult.next({ error: error?.error?.errors[0]?.message });
      });
  }

  modalTrigger(loc, content, error?) {
    const modalRef = this.modalService.open(OtpModalComponent, {
      windowClass: this.baseSiteId + ' OTP-main',
    })
    modalRef.componentInstance.otpChoices = !!error ? loc : {...loc,...content};
    modalRef.result.then((res) => {
        if (res.status == 'success') this.multiFactorAuthResult.next(
          res.process
          ? { process: res.process, status: true }
          : { status: true }
        )});
  }

  requestNewOTP(params?) {
    const url = !params ? '/new' : `/new?method=${params}`;
    return this.http.get(this.occEndPoint.buildUrl(url));
  }
  getMethodsOTP(process?) {
    return this.http.get(this.occEndPoint.buildUrl('/methods')).pipe(map(x => {
    const method = _.filter(x, { name: process});
    const verify = _.filter(x, { verified: true})?.length
      ? _.filter(x, otp => otp.verified == true && otp.value !== null)
      : _.filter(x, otp => otp.active == true && otp.value !== null)
      x = (process == 'e-mail' || process == 'mobile') ? (method ? method : verify) : verify;
    const active = _.filter(x, { active: true });
        return active ? active : null ;
    }));
  }

  validateOTP(otp, type) {
    const params = { otp: otp };
    return this.http.post(this.occEndPoint.buildUrl(`/validate?otp=${otp}&method=${type}`),
    params, { responseType: 'text' });
  }

  validateToken(token) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };
    return this.http.post(this.occEndPoint.buildUrl(`update-by-token?token=${token}`), token, httpOptions);
  }
}